// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Chats',
  new_chat: 'New chat',
  note: {
    team: "Everyone's chats on {{restaurant}}: yours, your team's and the restaurant's.",
    own: 'Your chats on {{restaurant}}.',
  },
  log: 'All requests in the Amigo log',
  days: {
    today: 'Today',
    yesterday: 'Yesterday',
    earlier: 'Earlier',
  },
  who: {
    you: 'You',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Owner',
      staff: 'Staff',
      partner: 'Partner',
    },
  },
  status: {
    done: 'Done',
    answered: 'Answered',
    waiting: 'Waiting for approval',
    partial: '{{applied}} of {{total}} applied',
    rejected: 'Rejected',
    not_yet: "Couldn't do yet",
    failed: 'Failed',
  },
  none: {
    title: 'No chats yet for {{restaurant}}',
    text: 'Chats you start here stay here, so you can come back to them.',
  },
  loading: 'Loading the chats…',
  loading_more: 'Loading more chats…',
  load_failed: "The chats couldn't be loaded.",
  retry: 'Try again',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'New answer:',
  new_answers_other: 'New answers:',
};
